import { memo, useCallback, useContext, useState } from 'react';
import cn from 'classnames';

import { Button } from 'UIPackage/MainModule/components/Button';
import { KnmAttachmentsSigning } from 'KnmPackage/MainModule/components/KnmAttachmentsSigning';
import { IKnmAttachment } from 'APIPackage/KnmModule/interfaces/IKnmAttachment';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { getTitleFieldWithRedStar } from 'functions/getTitleFieldWithRedStar';
import { AgreementsContext } from 'KnmErknmPackage/ErkmAgreementsModule/AgreementsContext';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';

import styles from './AgreementsPetitionAttachment.module.scss';
import { FileButtonErrorMessage } from '../FileButtonErrorMessage/FileButtonErrorMessage';

interface IAgreementsPetitionAttachmentProps {
  watchOnly: boolean;
  name: string;
  id: string;
  attachment: IKnmAttachment[] | null | undefined;
  formRef?: IKnmFormRef | IDecisionFormRef;
}

export const AgreementsPetitionAttachment = memo(
  ({ watchOnly, id, name, attachment, formRef }: IAgreementsPetitionAttachmentProps) => {
    const [isVisibleSignModal, setIsVisibleSignModal] = useState<boolean>(false);
    const { isKnm, isPm, isDecision } = useContext(AgreementsContext);

    const openSignModal = useCallback(() => setIsVisibleSignModal(true), []);
    const closeSignModal = useCallback(() => setIsVisibleSignModal(false), []);

    return (
      <div className={styles.ActDocument}>
        {(!attachment || attachment.length === 0) && (
          <>
            <Button
              className={cn('shared-btn-add', styles.ActDocumentAddButton)}
              text={getTitleFieldWithRedStar({
                label: 'Добавить файл ходатайства',
                field: name,
                isKnm,
                isPm,
                isDecision,
              })}
              variant="link"
              color="primary"
              type="button"
              id={id}
              disabled={watchOnly}
              onClick={openSignModal}
            />
            <FileButtonErrorMessage name={name} />
          </>
        )}

        <FieldBlock
          label={!!attachment && attachment.length > 0 && 'Файл ходатайства'}
          color="black"
          placementLabel="left"
          type="not-space"
          className={styles.FieldBlock}
        >
          <KnmAttachmentsSigning
            acceptedFiles=".pdf"
            isWatchOnly={watchOnly}
            name={name}
            isVisibleSignModal={isVisibleSignModal}
            closeSignModal={closeSignModal}
            formRef={formRef}
          />
        </FieldBlock>
      </div>
    );
  },
);
